import React, { useState, useEffect } from 'react'
import Draggable from 'react-draggable';
import { useDispatch, useSelector } from 'react-redux';
import Slide from '../../../carrousel/Slide';
import Dialog from '@material-ui/core/Dialog';
import { Button, Paper } from '@material-ui/core';
import { ViewPdf } from '../../../carrousel/ViewPdf';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { TIPO_CERTIFICADOS } from '../../../../utils/constants';
import { fetchCertificados } from '../../../../actions/certificados';
import { startAlerta } from '../../../../actions/ui/alertas';
import { getValidCertificadoIntegracion } from '../helperFunctions/ValidateCertificado';
import { ModalDocumentacionAfiliado } from './ModalDocumentacionAfiliado';

function PaperComponent(props) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

const CarritoCertificados = ({ idTipoCertificado, itemsCertificados, certificadoVigente, setCertificadoVigente, gestion, afiliadoAut }) => {
  const dispatch = useDispatch();

  const { afiliadoSeleccionado, solicitudDisca } = useSelector((state) => state.discapacidad);
  const {
    presupuestoSeleccionado,
    solicitudSeleccionada: solicitudAutorizaciones
  } = useSelector(
    (state) => state.autorizaciones
  );

  const [open, setOpen] = useState(false);
  const [docuSelectTitle, setDocuSelectTitle] = useState();
  const [openModalDocumentacion, setOpenModalDocumentacion] = useState(false);

  useEffect(() => {
    if (afiliadoSeleccionado && !gestion) {
      dispatch(fetchCertificados(afiliadoSeleccionado?.id_afiliado));
    } else if (gestion) {
      if (solicitudDisca?.afiliado?.id_afiliado)
        dispatch(fetchCertificados(solicitudDisca?.afiliado?.id_afiliado));
      else if (solicitudAutorizaciones?.afiliado?.id_afiliado)
        dispatch(fetchCertificados(solicitudAutorizaciones?.afiliado?.id_afiliado));
      else if (presupuestoSeleccionado?.afiliado?.id_afiliado)
        dispatch(fetchCertificados(presupuestoSeleccionado?.afiliado?.id_afiliado));
    }
  }, [dispatch, afiliadoSeleccionado, gestion, solicitudDisca, solicitudAutorizaciones, presupuestoSeleccionado]);

  useEffect(() => {
    if (idTipoCertificado)
      setCertificadoVigente(getValidCertificadoIntegracion(idTipoCertificado, itemsCertificados));
  }, [itemsCertificados, idTipoCertificado]);

  const handleClickOpen = (idTipoCertSelect, tipoCertSelect) => {
    if (!idTipoCertificado) {
      const certificadoValido = getValidCertificadoIntegracion(idTipoCertSelect, itemsCertificados);

      if (certificadoValido?.imagenCertificado?.length) {
        setOpen(true);
        setDocuSelectTitle(tipoCertSelect);
        setCertificadoVigente(certificadoValido);
      } else {
        dispatch(startAlerta(
          'Sin Certificado en vigencia cargado',
          'error',
          'Error'
        ));
      }
    } else {
      if (certificadoVigente) {
        setOpen(true);
        setDocuSelectTitle(Object.entries(TIPO_CERTIFICADOS).find(s => s[1] === idTipoCertificado)[0]);
      } else {
        dispatch(startAlerta(
          'Sin Certificado en vigencia cargado',
          'error',
          'Error'
        ));
      }
    }
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      {
        openModalDocumentacion &&
        <ModalDocumentacionAfiliado
          open={openModalDocumentacion}
          handleClose={() => setOpenModalDocumentacion(false)}
          afiliadoAut={afiliadoAut}
        />

      }
      <Paper style={{ overflow: "auto", whiteSpace: "nowrap", padding: "1rem" }}>
        {idTipoCertificado
          ?
          Object.entries(TIPO_CERTIFICADOS).filter(s => s[1] === idTipoCertificado).map((item, index) =>
          (
            <>
              <Button key={index} onClick={() => handleClickOpen(item[1], item[0])} variant="outlined" color="primary" style={{ marginRight: "0.5rem", marginLeft: "0.5rem" }}>{item[0]}</Button>
              <Button variant="outlined" color="primary" onClick={() => setOpenModalDocumentacion(true)} style={{ marginRight: "0.5rem", marginLeft: "0.5rem" }}>Generalidades</Button>
            </>
          ))
          :
          Object.entries(TIPO_CERTIFICADOS).map((item, index) =>
          (
            <Button key={index} onClick={() => handleClickOpen(item[1], item[0])} variant="outlined" color="primary" style={{ marginRight: "0.5rem", marginLeft: "0.5rem" }}>{item[0]}</Button>
          ))
        }
        <Dialog
          open={open}
          onClose={handleClose}
          PaperComponent={PaperComponent}
          aria-labelledby="draggable-dialog-title"
          BackdropProps={{ style: { backgroundColor: "transparent" } }}
        >
          <DialogTitle style={{ cursor: 'move', paddingBottom: 0 }} id="draggable-dialog-title">
            <span style={{ fontWeight: "bold" }}>{`${docuSelectTitle}`}</span>
          </DialogTitle>
          <DialogContent>
            <span>
              {`Fecha Emisión: ${new Date(certificadoVigente?.fecha).toLocaleString("es", optionsfecha)}`}
            </span>
            <br />
            {certificadoVigente?.fechaVencimiento
              ?
              <span>
                {`Fecha Vencimiento: ${new Date(certificadoVigente?.fechaVencimiento).toLocaleString("es", optionsfecha)} / `}
                {`Fecha 2do Vencimiento: ${certificadoVigente?.fecha2doVencimiento !== ''
                    ? new Date(certificadoVigente?.fecha2doVencimiento).toLocaleString("es", optionsfecha)
                    : ''
                  }`
                }
              </span>
              :
              <span>
                {`Fecha Actualizacion: ${new Date(certificadoVigente?.fechaActualizacion).toLocaleString("es", optionsfecha)}`}
              </span>
            }
            {certificadoVigente?.imagenCertificado?.length
              ?
              <Slide
                // url={`https://www.ospedyc.org.ar/onexa/webapi/Archivos/221474/637643685525320824.pdf`}
                url={`${process.env.REACT_APP_URL}/${certificadoVigente?.imagenCertificado[0].url}${certificadoVigente?.imagenCertificado[0].nombreDocumento}`}
                titulo={""}
                subtitle={""}
                media={
                  <ViewPdf url={`${process.env.REACT_APP_URL}/${certificadoVigente?.imagenCertificado[0].url}${certificadoVigente?.imagenCertificado[0].nombreDocumento}`} />
                  // <ViewPdf url={`https://www.ospedyc.org.ar/onexa/webapi/Archivos/221474/637643685525320824.pdf`} />
                }
                mediaBackgroundStyle={{ backgroundColor: "#fff" }}
                style={{ backgroundColor: "#fff" }}
              />
              :
              <h3>Sin Imagen Cargada</h3>
            }
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={handleClose} color="primary">
              CERRAR
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    </>
  )
}

export default CarritoCertificados
